import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/logo.svg'
import _imports_1 from '@/assets/images/cityName.svg'
import _imports_2 from '@/assets/images/superMestoTxt.svg'


const _hoisted_1 = { class: "wp1200 flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "crest" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Grb Logatec"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "crestText flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "city",
    alt: "Super mesto Logatec",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "superCity",
    alt: "Super mesto",
    src: _imports_2
  })
], -1)
const _hoisted_4 = { id: "topBar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "search"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_search" })
], -1)
const _hoisted_6 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Navigation = _resolveComponent("Navigation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      class: "responsiveMenuButton",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
    }),
    _createElementVNode("header", {
      class: _normalizeClass(["header", { active: _ctx.isMenuOpen }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: { name: 'Home' },
          class: "flex logo"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", {
            class: "menu",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
          }),
          _withDirectives(_createElementVNode("select", {
            class: "lang",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.$i18n.locale) = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateLocale()))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$i18n.availableLocales, (locale) => {
              return (_openBlock(), _createElementBlock("option", {
                key: `locale-${locale}`,
                value: locale
              }, _toDisplayString(locale.toUpperCase()), 9, _hoisted_6))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.$i18n.locale]
          ])
        ])
      ])
    ], 2),
    _createVNode(_component_Navigation, {
      class: _normalizeClass({ active: _ctx.isMenuOpen }),
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isMenuOpen = false))
    }, null, 8, ["class"])
  ], 64))
}